import React, { Component } from "react";
import { connect } from "react-redux";
import { TopKeywordsReport } from "../../components/TopKeywords";
import { fetchTopKeywords } from "../../store/top_keywords/operations";
import {
  getHasMore,
  getOffset,
  getKeywords,
  isFetchingKeywords,
  isFirstKeywordsFetch,
  getKeywordsToExportAsJson,
  getKeywordsToExportAsCsv
} from "../../store/top_keywords/selectors";

class TopKeywordsContainer extends Component {
  componentDidMount = _ => {
    this.props.fetchTopKeywords(this.props.domain, this.props.seoDb, this.props.orderBy, this.props.orderDir);
  };

  componentDidUpdate(prevProps) {
    if (
      (this.props.orderBy !== prevProps.orderBy || this.props.orderDir !== prevProps.orderDir) &&
      !this.props.offset
    ) {
      this.props.fetchTopKeywords(this.props.domain, this.props.seoDb, this.props.orderBy, this.props.orderDir);
    }
  }

  onLoadMore = _ => {
    this.props.fetchTopKeywords(
      this.props.domain,
      this.props.seoDb,
      this.props.orderBy,
      this.props.orderDir,
      this.props.offset
    );
  };

  render() {
    return (
      <TopKeywordsReport
        isLoading={this.props.isLoading}
        isFirstKeywordsFetch={this.props.isFirstKeywordsFetch}
        keywords={this.props.keywords}
        hasMore={this.props.hasMore}
        onLoadMore={this.onLoadMore}
        showSuggestions={this.props.showSuggestions}
        keywordsAsCsv={this.props.keywordsAsCsv}
        keywordsAsJson={this.props.keywordsAsJson}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { seoDb, orderBy, orderDir } = ownProps;
  const sortBy = `${seoDb}_${orderBy}_${orderDir}`;
  return {
    isLoading: isFetchingKeywords(state, sortBy),
    isFirstKeywordsFetch: isFirstKeywordsFetch(state, sortBy),
    hasMore: getHasMore(state, sortBy),
    offset: getOffset(state, sortBy),
    keywords: getKeywords(state, sortBy),
    keywordsAsJson: getKeywordsToExportAsJson(state, sortBy),
    keywordsAsCsv: getKeywordsToExportAsCsv(state, sortBy)
  };
};

export default connect(mapStateToProps, { fetchTopKeywords })(TopKeywordsContainer);
